import { useEffect } from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/ar'
import 'dayjs/locale/da'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/fi'
import 'dayjs/locale/nb'
import 'dayjs/locale/sv'
import { kebabCase } from 'lodash'

import { CoreIoUserDatetimeFormatLocaleChoices } from 'src/gen-types'

import { locale12Formats, locale24Formats } from './formats'
import { useMe } from '../../hooks'

dayjs.locale('en')

const locales = ['en', 'en-gb', 'da', 'fi', 'nb', 'sv', 'ar']

/**
 * Set dayjs locale based on user setting.
 */
const DayjsI18n = () => {
  const me = useMe()

  useEffect(() => {
    if (!me) return

    const locale =
      me.datetimeFormatLocale as CoreIoUserDatetimeFormatLocaleChoices
    const normalizedLocale = (locale?.replace('-', '_') ??
      'EN') as CoreIoUserDatetimeFormatLocaleChoices
    const userLocale = kebabCase(locale)
    const isClock12 = me.company?.settings?.clockFormat12
    const formatMap = isClock12 ? locale12Formats : locale24Formats

    if (!locales.includes(userLocale)) {
      // eslint-disable-next-line no-console
      console.log(
        new Error(
          `User date format setting: ${userLocale} is not supported by dayjs`
        )
      )
      return
    }

    dayjs.locale(userLocale)
    dayjs.updateLocale(userLocale, {
      formats: formatMap[normalizedLocale] ?? formatMap.EN,
    })
  }, [me])

  return null
}

export default DayjsI18n
